import {
    CREATE_NEWS_REQUEST,
    CREATE_NEWS_SUCCESS,
    CREATE_NEWS_FAILURE,
    RESET_CREATE_NEWS_DATA
} from '../actions/create-news-actions';

const initialState = {
    loading: false,
    error: null,
    response: null,
};

export default function createNewsReducer(state = initialState, action) {
    switch (action.type) {
        case CREATE_NEWS_REQUEST:
            return {...state, loading: true, error: null};
        case CREATE_NEWS_SUCCESS:
            return {...state, loading: false, response: action.payload};
        case CREATE_NEWS_FAILURE:
            return {...state, loading: false, error: action.payload};
        case RESET_CREATE_NEWS_DATA:
            return initialState;
        default:
            return state;
    }
}